// extracted by mini-css-extract-plugin
module.exports = {"paginationBox":"Pagination_paginationBox__dbDQb"};